import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SEO from "../components/SEO";
import PageHero from "../components/PageHero";
import { KVKK_TEXT, GIZLILIK_TEXT, COOKIE_TEXT } from "../data/legalTexts";

const SECTIONS = [
  { id: "kvkk", title: "KVKK Aydınlatma Metni", text: KVKK_TEXT },
  { id: "gizlilik", title: "Gizlilik Politikası", text: GIZLILIK_TEXT },
  { id: "cerez", title: "Çerez Politikası", text: COOKIE_TEXT },
];

export default function LegalPage() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [hash]);

  return (
    <>
      <SEO
        title="Yasal Bilgiler | Dijital Roket"
        description="Dijital Roket KVKK aydınlatma metni, gizlilik politikası ve çerez politikası."
        noindex
      />
      <PageHero eyebrow="Yasal" title="Yasal Bilgiler" subtitle="KVKK, gizlilik ve çerez politikalarımız." />
      <section className="section bg-white" data-testid="legal-page">
        <div className="container-x max-w-3xl space-y-16">
          {SECTIONS.map((s) => (
            <div key={s.id} id={s.id} className="scroll-mt-28" data-testid={`legal-${s.id}`}>
              <h2 className="font-heading text-2xl font-bold text-[#07111F]">{s.title}</h2>
              <p className="mt-5 whitespace-pre-line text-[15px] leading-relaxed text-[#334155]">{s.text}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
